import { useState } from "react";
import { Combobox, ComboboxInput, ComboboxOptions, ComboboxOption } from "@headlessui/react"; 
import { useOfferTemplates } from "../../contexts/OfferTemplatesContext";

const OfferTemplateSelector = ({ formData, setFormData }) => {
    const { offerTemplates } = useOfferTemplates();
    const [query, setQuery] = useState("");
    // console.log("list templates: ", offerTemplates);

    const filteredOfferTemplates = offerTemplates.filter(offerTemplate =>
        offerTemplate.name.toLowerCase().includes(query.toLowerCase())
    );

    const handleSelection = (selectedTemplate) => {
        if (!selectedTemplate) {
            // console.log("Selection cleared");
            setFormData({ ...formData, template_id: null });
            return;
        }

        // console.log("Selected offer template: ", selectedTemplate, "offer template id", selectedTemplate.id);
        setFormData({ ...formData, template_id: selectedTemplate.id });
    };

    return (
        <Combobox value={formData.template_id} onChange={handleSelection}>
            <div className="relative">
                <ComboboxInput
                    onChange={(event) => setQuery(event.target.value)}
                    displayValue={(templateId) => {
                        const selected = offerTemplates.find(c => c.id === templateId);
                        return selected ? selected.name : "";
                    }}
                    className="w-full dark:text-white dark:bg-black dark:border-gray-700 dark:focus:outline-none p-2 border border-gray-300 rounded"
                    placeholder="Select a template"
                    required
                />
                <ComboboxOptions className="absolute w-full dark:bg-black dark:text-white dark:border-gray-700 bg-white border border-gray-300 rounded mt-1 max-h-60 overflow-auto">
                    {filteredOfferTemplates.length === 0 ? (
                        <div className="p-2 text-gray-500 dark:text-white">No templates found</div>
                    ) : (
                        filteredOfferTemplates.map((template) => (
                            <ComboboxOption key={template.id} value={template} className="p-2 hover:bg-gray-200 cursor-pointer">
                                {template.name}
                            </ComboboxOption>
                        ))
                    )}
                </ComboboxOptions>
            </div>
        </Combobox>
    );
};

export default OfferTemplateSelector;
